import {Component, Input, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AuthService} from '../../../../services/auth.service';
import {BootService} from '../../../../services/boot.service';
import {ItemService} from '../../../../services/item.service';
import {TranslateService} from '../../services/translate.service';

interface IBreadcrumbPart {
    key: string;
    name: string;
}

@Component({
    selector: 'npa-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.styl']
})

export class BreadcrumbComponent implements OnInit {
    @Input() isSidebarMainClose;
    @Input() isSidebarUtilitiesClose;
    @Input() scrollTop;
    breadcrumbPart: IBreadcrumbPart[];
    itemId: string;
    lang: string;
    arrowIcon: string;

    constructor(private router: Router,
                private authService: AuthService,
                private bootService: BootService,
                private location: Location,
                private itemService: ItemService,
                private translate: TranslateService) {
        this.lang = this.translate.lang;
    }


    ngOnInit() {
        this.itemService.info.subscribe(item => {
            this.itemId = item.id;
            this.breadcrumbPart = [];
            this.buildBreadcrumb(this.location.path());
        });
        this.router.events.subscribe((data) => {
            if (!(data instanceof NavigationEnd)) {
                return;
            }
            const urlArray = data.url.split('/');
            const activatedRoute = urlArray[urlArray.length - 1];
            if (activatedRoute === 'list') {
                this.itemId = null;
            }
            this.breadcrumbPart = [];
            const urlString = data['urlAfterRedirects'];
            if (urlString !== undefined) {
                this.buildBreadcrumb(urlString);
            }
        });
        this.arrowIcon = this.lang === 'prs' ? 'keyboard_arrow_left' : 'keyboard_arrow_right';

    }

    private buildBreadcrumb(urlString: string) {
        urlString = this.authService.extractPath(urlString);
        const parts = urlString.split('/').slice(2);
        parts.forEach((item: string) => {
            this.breadcrumbPart.push({
                key: isNaN(Number(item)) ? this.translate.translateKey('TOP_BANNER.' + this.translate.normalize(item)) : item,
                name: item
            });
        });
    }

}
